"use client";
import React from "react";
import Link from "@/components/Link";
import { useMenu } from "react-instantsearch-core";

import { BlogFilterProps } from "@/components/Blog/BlogFilters/types";
import Label from "./FilterLabel";
import FilterContainer from "./FilterContainer";
import { BLOG_INDEX_URL } from "@/data/helpers/blog/urls";

const BlogSearchFilters: React.FC<BlogFilterProps> = ({ items }) => {
  const {
    refine,
    items: refineItems,
    createURL,
  } = useMenu({
    attribute: "category",
    limit: 1,
  });
  const activeItem = refineItems.find(({ isRefined }) => isRefined);

  return (
    <FilterContainer>
      <Link
        href={BLOG_INDEX_URL}
        onClick={() => refine("")}
        className="no-underline"
      >
        <Label>All</Label>
      </Link>
      {items.map(({ label, value }) => (
        <Link
          className="no-underline"
          href={createURL(value)}
          key={`filteritem:${value}`}
          onClick={() => refine(value)}
        >
          <Label active={activeItem?.value === value}>{label}</Label>
        </Link>
      ))}
    </FilterContainer>
  );
};

export default BlogSearchFilters;
